import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; border: string; hoverBg: string }> = {
  primary: {
    bg: 'bg-primary-50',
    text: 'text-primary-700',
    border: 'border-primary-200',
    hoverBg: 'hover:bg-primary-100',
  },
  accent: {
    bg: 'bg-accent-50',
    text: 'text-accent-700',
    border: 'border-accent-200',
    hoverBg: 'hover:bg-accent-100',
  },
  secondary: {
    bg: 'bg-secondary-50',
    text: 'text-secondary-700',
    border: 'border-secondary-200',
    hoverBg: 'hover:bg-secondary-100',
  },
};

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 bg-background-100" aria-labelledby="category-title">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-foreground-500 mb-3">
              分类浏览
            </span>
            <h2 id="category-title" className="font-heading text-3xl md:text-4xl text-foreground-950">
              探索你喜欢的<span className="text-primary-500">漫画类型</span>
            </h2>
            <p className="text-foreground-600 text-sm mt-2 max-w-md mx-auto">
              八大分类、八千余部作品，总有一部适合你
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {categories.map((cat) => {
              const colors = colorMap[cat.color] || colorMap.primary;
              return (
                <Link
                  key={cat.slug}
                  to="/category/all"
                  className={`group flex flex-col items-center p-6 rounded-xl border ${colors.border} ${colors.bg} ${colors.hoverBg} transition-all duration-300 cursor-pointer`}
                >
                  <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full ${colors.bg} mb-4 transition-transform duration-300 group-hover:scale-110`}>
                    <i className={`${cat.icon} text-2xl ${colors.text}`}></i>
                  </div>
                  <h3 className={`text-sm font-medium ${colors.text} mb-1 whitespace-nowrap`}>
                    {cat.name}
                  </h3>
                  <p className="text-foreground-500 text-xs">{cat.description}</p>
                  <span className="mt-3 inline-block px-3 py-1 rounded-full bg-background-50 text-foreground-500 text-xs">
                    {cat.count} 部作品
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}